import { RegistrationSubmit } from "./RegistrationSubmit";

export default RegistrationSubmit;
